import {XauditModel} from '../../../models/xaudit.model';

export class DoctorByTDOCIDModel extends XauditModel {
  DoctorId: string;
  FirstName: string;
  LastName: string;
  enumSalutationID: string;
  ContactId: string;
  FullName: string;
  UserId: string;
  LOCID: number;
  isActiveDoctor: boolean;
}
